import { FormField } from 'ui/formField';
import { BaseOption } from 'ui/selects/types';
import { Placement } from 'modules/placements/types';
import { SelectPlacementFormField } from 'modules/placements/components/PlacementsSelect/SelectPlacementFormField';
import { TemplateNameInput } from '../../components';
import { EMBEDDED_MODAL_CONTENT } from './constants';
import { StyledSelect } from './NewEmbeddedMessageTemplateModal.styled';

const { localesHelpText, localesPlaceholder, localesTitleLabel } = EMBEDDED_MODAL_CONTENT;

type CreateTemplateFormProps = {
  nameInputContent: string;
  templateName: string;
  setTemplateName: (value: string) => void;
  selectPlacement: (placementId: number) => void;
  localeOptions: BaseOption[];
  selectedLocaleTag: string;
  setSelectedLocaleTag: (value: string) => void;
  hasUnselectedPlacementError: boolean;
  placements: Placement[];
};

export const CreateTemplateForm = ({
  nameInputContent,
  templateName,
  setTemplateName,
  selectPlacement,
  localeOptions,
  selectedLocaleTag,
  setSelectedLocaleTag,
  hasUnselectedPlacementError,
  placements,
}: CreateTemplateFormProps) => {
  const SelectLocaleFormField = () => (
    <FormField
      data-test="flex-message-template-modal-form-field-locale"
      helpText={localesHelpText}
      labelText={localesTitleLabel}
    >
      <StyledSelect
        data-test="flex-message-template-modal-form-field-locale-select"
        defaultValues={[selectedLocaleTag]}
        id="flex-message-locale-select"
        onSelect={([localeTag]) => setSelectedLocaleTag(localeTag.toString())}
        options={localeOptions}
        placeholder={localesPlaceholder}
      />
    </FormField>
  );

  return (
    <>
      <TemplateNameInput
        content={nameInputContent}
        id="flex-message-template-name-input"
        setTemplateName={setTemplateName}
        templateName={templateName}
      />
      <SelectPlacementFormField
        placements={placements}
        selectPlacement={selectPlacement}
        errorMessage={hasUnselectedPlacementError && 'Please select a placement'}
      />
      {/* TODO: Once locales are re-introduced, insert <SelectLocaleFormField /> here */}
    </>
  );
};
